import { gridSizeMdLg12, ROUTER_PATHS, TABLE_CONSTANTS, useTableColumnsFactibilidadCorporativa, useTableFilter, useTableServerSideFiltering } from "@/shared"
import { useFetchGetfactibilidadCorporativos } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions"
import { GeneralTable } from "@/shared/components/ui"
import { Grid, IconButton, Tooltip } from "@mui/material"
import { Visibility } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useState } from "react"

export default function TableFactibilidadTabAprobada() {
  const navigate = useNavigate()
  const [rowSelection, setRowSelection] = useState({});

  const { columnsFactibilidad } = useTableColumnsFactibilidadCorporativa({ hideEstadoFactibilidad: true })

  const {
    pagination,
    setPagination
  } = useTableFilter()
  const { pageIndex, pageSize } = pagination
  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering()

  const {
    data,
    isLoading,
    isRefetching
  } = useFetchGetfactibilidadCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false,
    enviado_inventario_factibilidad: true,
  })

  return (
    <Grid container spacing={2} >

      <Grid item {...gridSizeMdLg12} mt={2}>
        <GeneralTable
          columns={columnsFactibilidad}
          data={data?.data?.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          //
          pagination={pagination}
          onPaging={setPagination}
          //
          enableGlobalFilter={false}
          //
          enableManualFiltering={true}
          enableSorting={false}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          //
          rowCount={data?.data.count}
          //
          canEdit={false}
          //activate check selector
          enableRowSelection
          enableSelectAll
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          //
          pinLeftColumnIndexes={[0,1,2]}
          //
          positionActionsColumn="first"
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(v) => {
            return (
              <>
                <Grid container item>
                  <Tooltip placement="top" title="Ver Factibilidad Corporativa">
                    <IconButton
                      onClick={() => {
                        navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/revision/${v.id_factibilidad_coorporativa}`)
                      }}
                    >
                      <Visibility />
                    </IconButton>

                  </Tooltip>

                </Grid>
              </>
            )

          }}

        />

      </Grid>

    </Grid>

  )

}